import checkIfBrowser from '../env/is-browser';
export { self, window, global, document, process, console } from '../env/globals';
export const VERSION = typeof __VERSION__ !== 'undefined' ? __VERSION__ : 'untranspiled source';
export const isBrowser = checkIfBrowser();
//# sourceMappingURL=globals.js.map